module.exports = __webpack_public_path__ + "static/media/list-marker.24869187.svg";